module.exports = __webpack_public_path__ + "img/bot23.01806647.png";